import React from 'react'
import styled from 'styled-components'
import { Checkbox } from 'spa/member/components/Checkbox'
import JobOffersQuerySelectModal from '../JobOffersQuerySelectModal'
import { CheckBoxProps } from '../../Checkbox/styled'

export type SearchConditionModalProps = {
  name: string,
  modalTitle: string,
  options: CheckBoxProps[],
  count: number,
  dataCy?: string,
  onSubmit: () => void,
  onClose: () => void,
}

const StyledUl = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  list-style: none;
  padding: 0;
  margin: 24px 16px;
`

const StyledLi = styled.li`
  width: 100%;
  margin-bottom: 1rem;

  @media ${props => props.theme.media.sm} {
    width: 50%;
  }
`

export const StyledListedQuerySearchConditionModal: React.FC<SearchConditionModalProps> = (props: SearchConditionModalProps) => {
  return (
    <JobOffersQuerySelectModal modalTitle={props.modalTitle} count={props.count} dataCy={props.dataCy} onSubmit={props.onSubmit} onClose={props.onClose}>
      <StyledUl>
        {props.options.map((option) => {
          return (
            <StyledLi key={option.value}>
              <Checkbox name={props.name} label={option.label} value={option.value} checked={option.checked} onChange={(e) => option.onChange(e)} />
            </StyledLi>
          )
        })}
      </StyledUl>
    </JobOffersQuerySelectModal>
  )
}
